(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dxEC4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dbddc5847e39269$export$71511d61b312f219; });
function $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dbddc5847e39269$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("gh3Df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd910d1ee9896911$export$71511d61b312f219; });
function $bd910d1ee9896911$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});


var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");
var $9534725903c08f96$export$7a5d735b2ab6389d = {
    copy: function() {
        return document.querySelectorAll('.socials__item--copy');
    },
    print: function() {
        return document.querySelectorAll('.socials__item--print');
    },
    toggle: function() {
        return document.querySelectorAll('.socials__item--share');
    }
};
var $9534725903c08f96$export$c6881760f06320dc = 'show';


var $8d19ec7c6340817b$export$96dcfe81b4f3e709 = function() {
    var _window_toastMessages, _window, _window_showToast, _window1;
    return (_window_showToast = (_window1 = window).showToast) === null || _window_showToast === void 0 ? void 0 : _window_showToast.call(_window1, (_window = window) === null || _window === void 0 ? void 0 : (_window_toastMessages = _window.toastMessages) === null || _window_toastMessages === void 0 ? void 0 : _window_toastMessages.copyLinkSuccess, 'success');
};
var $8d19ec7c6340817b$export$739bcfea9ba481d2 = function() {
    var _window_toastMessages, _window, _window_showToast, _window1;
    return (_window_showToast = (_window1 = window).showToast) === null || _window_showToast === void 0 ? void 0 : _window_showToast.call(_window1, (_window = window) === null || _window === void 0 ? void 0 : (_window_toastMessages = _window.toastMessages) === null || _window_toastMessages === void 0 ? void 0 : _window_toastMessages.copyLinkError, 'error');
};


// Open menu with several sharing options
(0, $9534725903c08f96$export$7a5d735b2ab6389d).toggle().forEach(function(el) {
    el.addEventListener('focus', function() {
        el.classList.add((0, $9534725903c08f96$export$c6881760f06320dc));
    });
});
// Copy URL functionality
(0, $9534725903c08f96$export$7a5d735b2ab6389d).copy().forEach(function(el) {
    el.addEventListener('click', function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _navigator_userAgentData, _navigator_userAgentData1, browser, os, windowsChrome, error;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //! Temporary fix for Google Chrome on Windows
                        browser = (_navigator_userAgentData = navigator.userAgentData) === null || _navigator_userAgentData === void 0 ? void 0 : _navigator_userAgentData.brands[0].brand;
                        os = (_navigator_userAgentData1 = navigator.userAgentData) === null || _navigator_userAgentData1 === void 0 ? void 0 : _navigator_userAgentData1.platform;
                        windowsChrome = 'Windows' === os && 'Google Chrome' === browser;
                        if (!(!windowsChrome && navigator.canShare && navigator.canShare({
                            url: window.location.href,
                            title: document.title,
                            text: document.title
                        }))) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.share({
                                title: document.title,
                                text: document.title,
                                url: window.location.href
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error('Error sharing content:', error);
                        $cee8fd0120b7084e$var$copyToClipboard();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (navigator.clipboard) $cee8fd0120b7084e$var$copyToClipboard();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    });
});
var $cee8fd0120b7084e$var$copyToClipboard = function() {
    if (navigator.clipboard) return navigator.clipboard.writeText(window.location.href).then((0, $8d19ec7c6340817b$export$96dcfe81b4f3e709), (0, $8d19ec7c6340817b$export$739bcfea9ba481d2));
    else console.error('Clipboard API not available');
};
// Print button
(0, $9534725903c08f96$export$7a5d735b2ab6389d).print().forEach(function(el) {
    el.addEventListener('click', function() {
        window.print();
    });
});

})();
//# sourceMappingURL=socials.min.js.map
